import olMousePostion from './../../node_modules/ol/control/MousePosition.js';
import {wrapX} from './../../node_modules/ol/coordinate.js';
import {
  get as getProjection,
  getTransformFromProjections,
  getUserProjection,
  identityTransform,
} from './../../node_modules/ol/proj.js';

export default class MousePosition extends olMousePostion {

  constructor(options) {
    super(options);
  }

  updateHTML_(pixel) {
    let html = this.placeholder_;

    if (pixel && this.mapProjection_) {

      if (!this.transform_) {
        const projection = this.getProjection();
        this.transform_ = projection
          ? getTransformFromProjections(this.mapProjection_, projection)
          : identityTransform;
      }

      const map = this.getMap();
      let coordinate = map.getCoordinateFromPixel(pixel);

      // 🎯 BullsEye override
      const bullsEye = map.get('BullsEyeControl');
      if (bullsEye?.active) {
          coordinate = bullsEye.getPosition();
      }

      if (coordinate) {
        const userProjection = getUserProjection();
        if (userProjection) {
          this.transform_ = getTransformFromProjections(
            this.mapProjection_,
            userProjection
          );
        }

        this.transform_(coordinate, coordinate);

        if (this.wrapX_) {
          const projection =
            userProjection || this.getProjection() || this.mapProjection_;
          wrapX(coordinate, projection);
        }

        const coordinateFormat = this.getCoordinateFormat();
        html = coordinateFormat
          ? coordinateFormat(coordinate)
          : coordinate.toString();
      }
    }

    if (html !== this.renderedHTML_) {
      this.element.innerHTML = html;
      this.renderedHTML_ = html;
    }
  }
}